import BaseStore from '@/store';
import actions from './orderSearch.actions.js';
import getters from './orderSearch.getters.js';
import mutations from './orderSearch.mutations.js';
import state from './orderSearch.state.js';

let store = {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
};

export default store;

export function tryRegisterStoreDynamically(id) {
	let path = `orderSearch/${  id  }/`;

	if (path in BaseStore._modulesNamespaceMap) {
		return false;
	}

	BaseStore.registerModule(path.slice(0, -1), store);
	return true;
}
